import { render, staticRenderFns } from "./waixiao.vue?vue&type=template&id=1884083e&scoped=true"
import script from "./waixiao.vue?vue&type=script&lang=js"
export * from "./waixiao.vue?vue&type=script&lang=js"
import style0 from "./waixiao.vue?vue&type=style&index=0&id=1884083e&prod&scoped=true&lang=css"
import style1 from "./waixiao.vue?vue&type=style&index=1&id=1884083e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1884083e",
  null
  
)

export default component.exports